import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { isEmpty } from "lodash";

import { ButtonComp, Icon } from "components";
import { getArtieLogo, getIsMaximized, removeAndAddMessages } from "slices";
import { renderMascot } from "utils";

import { MessageTimeStamp } from "./MessageTimeStamp/index";

const AgentHandOff = ({ isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, message, createdAt }) => {
  const dispatch = useDispatch();
  const artieLogo = useSelector(getArtieLogo);
  const isMaximized = useSelector(getIsMaximized);

  const OnSchedule = () => {
    dispatch(
      removeAndAddMessages([
        { message: message, speaker: "faqBot", subject: "", createdAt: createdAt },
        { message: "", speaker: "faqBot", subject: "contact us" },
      ])
    );

    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_clicked_location: "contact_us",
        h_stream: "hyly",
        h_display_method: "iframe",
      },
    };
    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  const handleCancel = () => {
    dispatch(
      removeAndAddMessages([
        { message: message, speaker: "faqBot", subject: "", createdAt: createdAt },
        { message: "No", speaker: "user", createdAt: new Date() },
      ])
    );
  };

  return (
    <>
      <div style={{ overflowWrap: "break-word" }}>
        <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
          {isUserMsg ? (
            isMaximized ? (
              <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
            ) : (
              ""
            )
          ) : (
            <>
              {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

              {!isEmpty(artieLogo) && (
                <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                  <img
                    id="staticImage"
                    src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                    alt=""
                    className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                  />
                </div>
              )}
            </>
          )}
          <div className="hayley-mx-3">
            <div className="hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
              <div dangerouslySetInnerHTML={{ __html: message }} />
            </div>
            {createdAt && <MessageTimeStamp time={createdAt} isUserMsg={isUserMsg} isMaximized={isMaximized} />}
          </div>
        </div>
      </div>
      <div style={{ overflowWrap: "break-word" }}>
        <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
          {isUserMsg ? (
            isMaximized ? (
              <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
            ) : (
              ""
            )
          ) : (
            <>
              {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

              {!isEmpty(artieLogo) && (
                <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                  <img
                    id="staticImage"
                    src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                    alt=""
                    className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                  />
                </div>
              )}
            </>
          )}
          <div className="hayley-mx-3">
            <div className="hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
              {"Would you like to chat with a member of our team?"}
            </div>
            <div className="hayley-mt-3 hayley-flex hayley-items-center hayley-gap-2">
              <ButtonComp filled label={t("Yes")} onClick={OnSchedule} />
              <ButtonComp label={"No"} onClick={handleCancel} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentHandOff;
